/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="mc-form-carpool">

    <div class="mc-select-type">
      <ion-radio-group v-model="carpoolToPost.role" @ionChange="changeRole($event.target.value)">
        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-radio :value="1"></ion-radio>
              <ion-label>{{ $t('PostCarpool.driver')}}</ion-label>
            </ion-item>
          </ion-col>
          <ion-col v-if="!carpoolToPost.solidaryExclusive">
            <ion-item lines="none">
              <ion-radio :value="2"></ion-radio>
              <ion-label>{{ $t('PostCarpool.passenger')}}</ion-label>
            </ion-item>
          </ion-col>
          <ion-col v-if="!carpoolToPost.solidaryExclusive && hasBothRole">
            <ion-item lines="none">
              <ion-radio :value="3"></ion-radio>
              <ion-label>{{ $t('PostCarpool.driverOrPassenger')}}</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-radio-group>
    </div>

    <div class="mc-select-origin-destination">
      <!-- Input with placeholder -->
        <ion-item  v-on:click="goGeoSearch('origin', 'post')">
          <ion-input
            type="text"
            class="no-clickable ellipsis"
            :placeholder="$t('Search.origin')"
            :value="displayOrigin"
            >
          </ion-input>
          <ion-icon name="close" v-on:click="clearInput($event, 'origin')"></ion-icon>
        </ion-item>
        <div v-if="v$.addressessUseToPost.origin.$error">
          <div class="mc-error-label"  v-if="v$.addressessUseToPost.origin.required.$invalid">{{$t('Validation.required')}}</div>
        </div>

        <div class="mc-div-icon-swap">
         <ion-icon v-on:click="swapDestinationAndOrigin()"
            class="mc-rotate-icon"
            name="swap-horizontal"
            color="primary"
            size="large">
          </ion-icon>
        </div>

        <ion-item v-on:click="goGeoSearch('destination', 'post')">
          <ion-input
            type="text"
            class="no-clickable ellipsis"
            :placeholder="$t('Search.destination')"
            :value="displayDestination"
            >
          </ion-input>
          <ion-icon name="close" v-on:click="clearInput($event, 'destination')"></ion-icon>
        </ion-item>
        <div v-if="v$.addressessUseToPost.destination.$error">
          <div class="mc-error-label"  v-if="v$.addressessUseToPost.destination.required.$invalid">{{$t('Validation.required')}}</div>
        </div>

    </div>

    <div class="mc-select-regular">
      <ion-grid>
        <ion-row>
        <ion-col>
          <ion-item lines="none">
            <ion-label>{{$t('PostCarpool.regular')}}</ion-label>
            <ion-checkbox slot="start"
                          :checked="this.$store.getters.carpoolToPost.frequency == 2"
                          @ionChange="changeFrequency()">
            </ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item v-if="this.$store.getters.carpoolToPost.frequency == 1" lines="none">
            <ion-datetime-button datetime="datePicker"></ion-datetime-button>
            <ion-modal :keep-contents-mounted="true">
              <ion-datetime
                id="datePicker"
                presentation="date"
                display-format="DD/MM/YY"
                picker-format="DD/MM/YY"
                cancel-text="Annuler"
                done-text="Valider"
                :show-default-buttons="true"
                :placeholder="$t('PostCarpool.dayOutward')"
                :max="'2099-12-31T23:59:59.000Z'"
                :value="this.$store.getters.carpoolToPost.outwardDate"
                :first-day-of-week="1"
                :min="new Date().toISOString()"
                @ionChange="changePostOutwardDate($event)"
              ></ion-datetime>
            </ion-modal>
          </ion-item>
          <div v-if="v$.carpoolToPost.outwardDate.$error">
            <div class="mc-error-label"  v-if="v$.carpoolToPost.outwardDate.required.$invalid">{{$t('Validation.required')}}</div>
          </div>
        </ion-col>
        </ion-row>
      </ion-grid>

    </div>



  </div>
</template>

<style lang="scss">
 .mc-form-carpool{
   .mc-select-type {
     margin-top: 40px;
     margin-bottom: 40px;
     ion-radio {
       margin-right: 10px;
     }
   }

   .mc-select-origin-destination {
     margin-bottom: 40px;
   }
 }
</style>

<script>
import {
  required,
  email,
  sameAs,
  minLength,
  helpers,
  requiredIf
} from '@vuelidate/validators';
import { address } from "../../Shared/Mixin/address.mixin";
import { toast } from "../../Shared/Mixin/toast.mixin";
import useVuelidate from "@vuelidate/core";

export default {
  name: "post-carpool-step1",
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      hasBothRole: JSON.parse(process.env.VUE_APP_HAS_BOTH_ROLE_FOR_PUBLISH)
    };
  },
  mixins: [address, toast],
  validations() {return {
    carpoolToPost: {
      role: {
        required,
      },
      outwardDate: {
        required: requiredIf(function (outwardDate) {
          return this.$store.getters.carpoolToPost.frequency == 1
        })
      },
    },
    addressessUseToPost: {
      origin: {
        required
      },

      destination: {
        required
      }
    },
  }},
  created() {
      console.log(this.carpoolToPost)
  },
  computed: {
    carpoolToPost() {
      return this.$store.getters.carpoolToPost;
    },

    addressessUseToPost() {
      return this.$store.getters.addressessUseToPost;
    },

    displayOrigin() {
      const addressess = this.$store.getters.addressessUseToPost;

      /*
      if (!! addressess && addressess.origin){

        if (!! addressess.origin.displayLabel) {
          result = `${addressess.origin.displayLabel[0]},  ${addressess.origin.displayLabel[1]}`;
        } else {
          result = `${addressess.origin.addressLocality},  ${addressess.origin.addressCountry}`;
        }
      }*/
      return this.formatAddress(addressess.origin);
    },

    displayDestination() {
      const addressess = this.$store.getters.addressessUseToPost;
      return this.formatAddress(addressess.destination);
    }

  },
  methods: {
    validate() {
      this.v$.$reset();
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.presentToast(this.$t("Commons.form-error"), "danger");
        return false;
      } else {
        return true;
      }
    },

    changeRole: function(value) {
      this.$store.getters.carpoolToPost.role = parseInt(value);
      this.$emit('changeRole', value)
    },

    changeFrequency: function() {
      if (this.$store.getters.carpoolToPost.frequency == 1) {
        this.$store.getters.carpoolToPost.frequency = 2;
      } else {
        this.$store.getters.carpoolToPost.frequency = 1;
      }
    },

    goGeoSearch: function(type, action) {
      this.$router.push({ name: "geoSearch", query: { type, action }});
    },

    swapDestinationAndOrigin: function() {
      this.$store.dispatch('swapPostDestinationAndOrigin');
      this.$store.dispatch('treatementUpdateAddresses');
    },

    clearInput($event, type) {
      $event.stopPropagation();
      this.$store.getters.addressessUseToPost[type] = '';
    },

    changePostOutwardDate($event) {
      this.$store.commit('changeDateOutwardCarpool', {outwardDate: new Date($event.detail.value).toISOString()})
      this.$store.commit('changeDateReturnCarpool', {returnDate: new Date($event.detail.value).toISOString()})
    },
  }
};
</script>
